import React from 'react'
import { Badge } from 'components/Form'
import { WrapSideBarItem, SelectedSideBarItem } from './Styled'
import PermissionHOC from 'components/Permissions/PermissionHOC'

const SideBar = (props) => {
    const { disabled, hideBorder, feature, selected, label, action, subItem, badge } = props

    return (
        <WrapSideBarItem
            disabled={feature?.disabled || disabled}
            onClick={() => action(props)}
            $subItem={subItem}
            variant={"text"}
            $selected={selected}
            color={selected ? 'secondary' : 'white'}
        >
            <SelectedSideBarItem $selected={selected} $hideBorder={hideBorder} />
            <div className='item-content'>
                <div className='item-label-and-icon'>
                    <div className='sub-item-icon'>
                        {!subItem && <props.icon sx={{ fill: "red" }} fontSize={"18"} />}
                    </div>
                    {label}
                </div>
                {badge && <Badge value={badge} />}
            </div>
        </WrapSideBarItem>
    )
}

export default PermissionHOC(SideBar)